import VsbOrchAdapter from './api';
import checkout from './api/checkout';
import completeIdentityValidation from './api/complete-identity-validation';
import getSrcProfiles from './api/get-set-src-profiles';
import identityLookup from './api/identity-lookup';
import initiateIdentityValidation from './api/initiate-identity-validation';
import unbindAppInstance from './api/unbind-app-instance';
import { DATA_DELIM } from './constants/common';
import * as DATAELEMENTS from './constants/custom-data-elements';
import * as EVENTS from './constants/external-events';
import handleInit from './handlers/handle-init';
import handleIsRecognizedPreference from './handlers/handle-is-recognized-preference';
import handleSdkInit from './handlers/handle-sdk';
import collapsedLogger from './helpers/collapsed-logger';
import fixMessage from './helpers/fix-message';
import logger from './helpers/logger';
import OrchCustomData from './helpers/orch-custom-data';
import resetCustomData from './helpers/reset-data';
import sendMessageToVisaSrci from './helpers/send-message-to-visa-srci';

const _receivePostMessage = event => {
  if (!event.data || typeof event.data !== 'string') {
    return;
  }

  // original code splits and then looks for array.length > 2
  if (event.data.indexOf(DATA_DELIM) < -1) {
    return;
  }

  const rawMessage = event.data.split(DATA_DELIM);
  // Ensure that message is parsed correctly, eg. handle API keys with --
  const message = fixMessage([rawMessage[0]], rawMessage[1], rawMessage.slice(2), DATA_DELIM);

  //listen only for visa.orch events
  const eventsArray = Object.values(EVENTS);
  if (typeof message[0] === 'object' || eventsArray.indexOf(message[0]) < 0) {
    return;
  }
  logger('SRC ORCH-=-Event: ', message[0]);
  collapsedLogger(' SRC ORCH -- _receivePostMessage => ', message[1]);
  try {
    const data = JSON.parse(message[1]);

    switch (message[0]) {
      case EVENTS.ORCH_INIT:
        handleInit();
        break;
      case EVENTS.ORCH_IS_RECOGNIZED:
        handleIsRecognizedPreference(data);
        break;
      case EVENTS.ORCH_IDENTITY_LOOKUP:
        identityLookup(data);
        break;
      case EVENTS.ORCH_INITIATE_IDENTITY_VALIDATION:
        initiateIdentityValidation(data);
        break;
      case EVENTS.ORCH_COMPLETE_IDENTITY_VALIDATION:
        completeIdentityValidation(data);
        break;
      case EVENTS.ORCH_GET_SRC_PROFILE:
        getSrcProfiles();
        break;
      case EVENTS.ORCH_CHECKOUT:
        checkout(data);
        break;
      case EVENTS.SYS_SESSION_START:
        sendMessageToVisaSrci(EVENTS.SYS_SESSION_START, data);
        break;
      case EVENTS.ORCH_INO_DECISION:
      case EVENTS.ORCH_RXO_DECISION:
        handleSdkInit(data);
        break;
      case EVENTS.ORCH_RXO_SSIOPTOUT:
        const idToken = OrchCustomData.srcSdks.orchConfig.dcfIdToken || {};
        unbindAppInstance({ idToken });
        resetCustomData(DATAELEMENTS.IS_RECOGNIZED);
        OrchCustomData.clearApiResponseCache();
        break;
      case EVENTS.VSB_CANCEL:
      case EVENTS.VSB_COMPLETE:
      case EVENTS.VSB_ERROR:
        if (OrchCustomData.checkoutCallback) {
          OrchCustomData.checkoutCallback(message[0].split('.')[2].toUpperCase(), data);
          delete OrchCustomData.checkoutCallback;
        }
        break;
    }
  } catch (e) {
    console.error(e); // eslint-disable-line
  }
};

if (window.removeEventListener) {
  window.removeEventListener('message', _receivePostMessage);
} else if (window.detachEvent) {
  window.detachEvent('onmessage', _receivePostMessage);
}

if (window.addEventListener) {
  window.addEventListener('message', _receivePostMessage);
} else if (window.attachEvent) {
  window.attachEvent('onmessage', _receivePostMessage);
}

window.vAdapters = window.vAdapters || {};
// instantiate new orch adapter as vAdapters.VSB
window.vAdapters.VSB = new VsbOrchAdapter() || {};
